import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { TimeSegment, minuteCalc } from '@/logic/_infra/time';
import { Timespending } from '@/app.context/workspace/Event';
import { EffortRmodel, Timeffort } from '@/app.context/workspace/persons/sunrises/effort.rmodel'
import { Direction, SegmentEnd } from '@/logic/_infra/_tech';
import TimelineFullSubClocksComponent from './TimelineFullSubClocksComponent.vue'
import TimelineSimpleSubClocksComponent from './TimelineSimpleSubClocksComponent.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeffortTextComponent_Timeline',
  props: {
    item: {},
    span: {}
  },
  emits: {
    "click"(d: Direction, e: SegmentEnd, effort: EffortRmodel, timeffort: Timeffort | null, timespending: Timespending | null) {

        return true
    }
},
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props


return (_ctx: any,_cache: any) => {
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.item.isTicket())
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.item.objects.ticket != null)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" #" + _toDisplayString(_ctx.item.objects.ticket.n) + " " + _toDisplayString(_ctx.item.objects.ticket.name) + " ", 1),
                _createElementVNode("i", null, [
                  (_ctx.span ?? 1 > 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, "(" + _toDisplayString(_unref(minuteCalc).toAproximatedHoursString(_ctx.span!)) + ")", 1))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" #" + _toDisplayString(_ctx.item.ticket_n) + " (" + _toDisplayString(_ctx.item.ticket_type) + ") ", 1)
              ], 64))
        ], 64))
      : (_ctx.item.isSpecial())
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
        : (_openBlock(), _createBlock(_component_Error, { key: 2 }))
  ]))
}
}

})